import {isDesktop} from 'react-device-detect'

export const FACEBOOK_URL = 'https://www.facebook.com/share.php'
export const TWITTER_URL = 'https://twitter.com/share'
export const WHATSAPP_URL = `https://${
  isDesktop ? 'web' : 'api'
}.whatsapp.com/send`
